import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import FooterWrapper from '../FooterWrapper';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const BodyPage = styled.div<{ standardSpacing?: boolean; paddingFooter?: boolean }>`
  ${({ standardSpacing, paddingFooter }) => css`
    padding: ${!standardSpacing ? '0 32px' : '0'};
    padding-bottom: ${paddingFooter ? '110px' : '0'};
    padding-top: ${!standardSpacing ? '36px' : '0'};
    overflow-y: auto;
    height: 100%;
  `}
`;

export const FieldWrapper = styled.div`
  margin-top: 16px;
`;

export const FooterWrapperTransparent = styled.div`
  background: linear-gradient(#ffffff00, #ffffffff);
  padding: 24px 32px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

type ContainerPageProps = {
  children: ReactNode;
  childrenFooter?: ReactNode;
  childrenFooterTransparent?: ReactNode;
  standardSpacing?: boolean;
};
const ContainerPage: React.FC<ContainerPageProps> = (
  { children, childrenFooter, standardSpacing, childrenFooterTransparent },
  ...rest
) => {
  return (
    <Container {...rest}>
      <BodyPage standardSpacing={standardSpacing} paddingFooter={!!childrenFooterTransparent}>
        {children}
      </BodyPage>
      {childrenFooter && <FooterWrapper>{childrenFooter}</FooterWrapper>}
      {childrenFooterTransparent && <FooterWrapperTransparent>{childrenFooterTransparent}</FooterWrapperTransparent>}
    </Container>
  );
};

export default ContainerPage;
